import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, throwError } from "rxjs";
import { Endpoints } from "../../shared/config/endpoints";
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.state';
export interface newCardRepI {
  leads?: any[],
  salespersons?: object;
  invoices?: any[];
  contacts?: any[];
  companys?: any[];
}
@Injectable({
  providedIn: "root",
})
export class PerformanceReportService {
  orgID;
  private salesUrl = this.endpoints.salesUrl;

  selected_users: any = new BehaviorSubject<any>([]);
  new_cards_reports = new BehaviorSubject<newCardRepI>({});

  constructor(
    private endpoints: Endpoints,
    private http: HttpClient,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.orgID = info.organization.id;
    });
  }

  transFormNewReportData(datasets: any[], salespersons, dtKey) {
    const salesPerLeads = {};
    datasets.forEach(data => {
      if (!data[dtKey]) {
        data.owner = 'Not Assigned';
      }
      if (salesPerLeads[data[dtKey]]) {
        let count = salesPerLeads[data[dtKey]];
        count = count + 1;
        salesPerLeads[data[dtKey]] = count;
      } else {
        salesPerLeads[data[dtKey]] = 1
      }
    });
    const result = { data: [], categories: [] };
    Object.entries(salesPerLeads).forEach(([spId, count]) => {
      const spIdNo = Number(spId) ? Number(spId) : spId;
      const spName = salespersons[spIdNo] ? salespersons[spIdNo].fullName : spIdNo;
      result.data.push(count);
      result.categories.push(spName);
    })
    return result;
  }

  getRevenue(year, teamID, spID) {
    return this.http.get(this.salesUrl + `/${year}/${this.orgID}/${teamID}/${spID}/getSalesOrderGraphStats`);
  }
}
